module.exports = __webpack_public_path__ + "assets/img/048.2d3d93c4.png";